import React from 'react';
import { VARIANT_MAP } from '../../FlowChart.meta';
import { Avatar as BaseAvatar } from './Avatar.styles';
import { Icon } from '../../../../../../../../../../CommonComponents/OPL/Icon/Icon';
import { ItemType } from '../../../../api/useEstatePlanningFlowQuery';
import { useIsPdf } from '../../../../../../../../../hooks/useIsPdf';

const MAX_AVATARS = 4;

interface Props {
  type?: ItemType;
  nameList?: string[];
}

export const Avatar = ({ type, nameList = [] }: Props) => {
  const isPrint = useIsPdf();

  if (!type) {
    return <BaseAvatar color="neutral" size={isPrint ? 'extraSmall' : 'small'} />;
  }

  if (
    !nameList ||
    nameList.length === 0 ||
    type === ItemType.TaxesAndFees ||
    type === ItemType.CharityBeneficiaries
  ) {
    return (
      <BaseAvatar color={VARIANT_MAP[type]} size={isPrint ? 'extraSmall' : 'small'}>
        {type === ItemType.TaxesAndFees && (
          <Icon
            className="fas fa-dollar-sign"
            color="neutral.500"
            fontSize={isPrint ? 'small' : 'h4'}
          />
        )}

        {type === ItemType.CharityBeneficiaries && (
          <Icon
            className="fa fa-home-heart"
            color="yellow.700"
            fontSize={isPrint ? 'small' : 'h4'}
          />
        )}
      </BaseAvatar>
    );
  }

  const shouldShowCounter = nameList.length > MAX_AVATARS;
  const slicedNameList = nameList.slice(0, shouldShowCounter ? MAX_AVATARS - 1 : MAX_AVATARS);
  const hiddenAvatarsCount = nameList.length - slicedNameList.length;

  return (
    <>
      {slicedNameList.map((name, nameIndex) => {
        return (
          <BaseAvatar
            key={nameIndex}
            color={VARIANT_MAP[type]}
            size={isPrint ? 'extraSmall' : 'small'}
          >
            {name
              .split(' ')
              .map(word => word[0])
              .join('')}
          </BaseAvatar>
        );
      })}

      {shouldShowCounter && (
        <BaseAvatar color={VARIANT_MAP[type]} size={isPrint ? 'extraSmall' : 'small'}>
          {`+${hiddenAvatarsCount}`}
        </BaseAvatar>
      )}
    </>
  );
};
